import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input, OnChanges } from '@angular/core';

import {
  DnvMapState, CenterMap, SetZoom, DnvMapAction, CheckMarkerPosition, LayerState
} from 'dnv-lib';

import { MenuItem, ProblemType } from '../../state-management';

import { Problem } from '../../models/problem';
import { DashboardView } from '../../state-management';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-map-view',
    templateUrl: './map-view.component.html',
    styleUrls: ['./map-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class MapViewComponent implements OnInit, OnChanges {
  @Output() toggleProblem = new EventEmitter<Problem>();
  @Output() mapUpdate = new EventEmitter<DnvMapAction>();
  @Output() viewLoaded = new EventEmitter<boolean>();
  @Input() dashboardView: DashboardView;
  @Input() problems: Problem[];
  @Input() noPin: boolean;
  @Input() selectedProblem: string;
  @Input() windowInnerWidth: number;
  @Input() mapState: DnvMapState;
  @Input() layerState: LayerState;
  @Input() problemTypes: Map<number, ProblemType>;

  environment = environment;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.problems.length > 0) {
      this.viewLoaded.emit(true);
    }
  }

  theSelectedProblem(selectedProblem: string | null = null): Problem | null {
    selectedProblem = selectedProblem || this.selectedProblem;
    let problem;
    if (this.problems !== undefined && this.problems.length > 0) {
      problem = this.problems.find(p => p.problemNo === selectedProblem);
      if (problem) {
        return problem;
      }
    }

    return null;
  }

  onMapUpdate(action: any) {
    if(action.length > 0){
      action = action[0];
    }

    if (action.type?.indexOf('MarkerClick') > -1) {

      const problem = this.theSelectedProblem(action.payload);
      if (problem) {
        this.toggleProblem.emit(problem);

        if (this.dashboardView === 'map') {

          let markerOpts = {
            latlng: problem.latLng,
            hSpace: 0,
            vSpace: 0,
            unit: '',
            direction: ''
          };

          // mobile
          if (this.windowInnerWidth < 576) {

            markerOpts = {
              latlng: problem.latLng,
              hSpace: 0,
              vSpace: 300, // amount of map being covered
              unit: 'pixel',
              direction: 'top'
            };
          } else { // desktop
            markerOpts = {
              latlng: problem.latLng,
              hSpace: 30, // amount of map being covered
              vSpace: 0,
              unit: 'percentage',
              direction: 'left'
            };
          }
          this.mapUpdate.emit(new CheckMarkerPosition(markerOpts));
        }

      }

    } else {
      this.mapUpdate.emit(action);
    }

  }

  onMoveChange(state: DnvMapState) {
    this.mapUpdate.emit(new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng }));
  }

  onZoomChange(state: DnvMapState) {
    this.mapUpdate.emit(new SetZoom(state.zoomLevel));
  }

  closeDetails(problem: Problem) {
    this.toggleProblem.emit(problem);
  }

  getProblemTypeName(problemType_Id: number) {
    return this.problemTypes.get(problemType_Id).problemType_Name;
  }
}
